"use client";

import React from "react";
const partners = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/partner_logo_apex.png",
  alt: "Erdemir Steel Works"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/partner_logo_buildit.png",
  alt: "Maersk Global Logistics"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/partner_logo_civilcorp.png",
  alt: "İskenderun Iron & Steel"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/partner_logo_dynatech.png",
  alt: "MSC Mediterranean Shipping"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/partner_logo_echofab.png",
  alt: "ArcelorMittal"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/partner_logo_forge.png",
  alt: "Hapag-Lloyd"
}, {
  id: 7,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/partner_logo_global.png",
  alt: "CMA CGM Group"
}];
export default function IndustryCollaborations() {
  const marqueeItems = [...partners, ...partners];
  return <section data-section-id="224939" id="trusted-by-industry-giants" className="relative py-24 bg-background text-foreground overflow-hidden border-y border-secondary/30">
      <style>{`
        @keyframes marquee-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee-infinite {
          animation: marquee-scroll 40s linear infinite;
          width: max-content;
        }
      `}</style>

      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-10 pointer-events-none [mask-image:linear-gradient(to_bottom,transparent,black_20%,black_80%,transparent)]" />

      {}
      <div className="absolute top-6 left-6 w-8 h-8 border-t border-l border-primary/40 pointer-events-none" />
      <div className="absolute bottom-6 right-6 w-8 h-8 border-b border-r border-primary/40 pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-sm font-mono tracking-widest text-primary uppercase">
            Strategic Partners in Global Metal Supply Chains
          </h2>
        </div>

        {}
        <div className="relative flex overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_15%,black_85%,transparent)]">
          <div className="flex items-center gap-16 animate-marquee-infinite hover:[animation-play-state:paused] pr-16">
            {marqueeItems.map((partner, i) => <div key={`${partner.id}-${i}`} data-index={i} className="flex-shrink-0 flex items-center justify-center w-48 h-24">
                <img src={partner.src} alt={partner.alt} className="max-w-full max-h-full object-contain grayscale brightness-0 invert opacity-50 transition-all duration-700 ease-in-out hover:opacity-100 hover:scale-105 cursor-pointer" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}